import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import user from "../../Assets/Image/admin/user.png";
import deletes from "../../Assets/Image/admin/delete.png";
import add from "../../Assets/Image/admin/add.png";
import Dialog from "../../Base-Component/Dialog/Dialog";
import noImage from "../../Assets/Image/admin/user.png";
import Eye from "../../Assets/Image/admin/eye.png";
import EyeSlash from "../../Assets/Image/admin/slasheye.png";
import back from "../../Assets/Image/admin/background2.png";
import {
  addUsers,
  deleteUsers,
  getUserList,
  listUserRole,
  updateUsers,
} from "../../Services/ApiServices";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { IMG_URL } from "../../Services/Api";
import edit from "../../Assets/Image/admin/edit.png";
import cancel from "../../Assets/Image/admin/cancel.png";
import { useDebounce } from "use-debounce";
import moment from "moment/moment";
import FormSelect from "../../Base-Component/FormSelect/FormSelect";

function Users() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [isModalOpens, setModalOpens] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isAddUser, setIsAddUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [eyes, setEyes] = useState(0);
  const [eyess, setEyess] = useState(0);

  const [texts, setTexts] = useState("password");
  const [textss, setTextss] = useState("password");
  const [searchData, setSearchData] = useState("");
  const [totalPage, setTotalPage] = useState("");
  const [image, setImage] = useState("");
  const [img, setImg] = useState("");
  const [userId, setUserId] = useState({});
  const [isIndex, setIsIndex] = useState("");
  const [isRole, setIsRole] = useState("");

  const [formValue, setFormValue] = useState({});

  const [userData, setUserData] = useState([]);
  const [userRoleData, setUserRoleData] = useState([]);

  const [search] = useDebounce(searchData, 500);

  const handleUserList = () => {
    setLoader(true);
    let obj = {
      page: pageNo,
    };

    if (search) {
      obj.search = search;
    }

    if (isRole) {
      obj.role = isRole;
    }

    getUserList(obj)
      .then((res) => {
        const data = res.data.data;
        setUserData(data);
        setTotalPage(res.data.totalPages);
        setLoader(false);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setLoader(false);
      });
  };

  const handleSearchChange = (e) => {
    setSearchData(e.target.value);
    setPageNo(1);
  };

  const handleUserRoleList = () => {
    listUserRole()
      .then((res) => {
        const data = res.data.data;
        setUserRoleData(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
      });
  };

  useEffect(() => {
    handleUserList();
  }, [pageNo, search, isRole]);

  useEffect(() => {
    handleUserRoleList();
  }, []);

  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    document.body.style.userSelect = "none";
  };

  const stopDragging = () => {
    setIsDragging(false);
    document.body.style.userSelect = "";
  };

  const onDragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleFile = (e) => {
    setImage(e.target.files[0]);
    let imageData = URL.createObjectURL(e.target.files[0]);
    setImg(imageData);
  };

  const handleEyes = () => {
    const flag = eyes == 0 ? 1 : 0;
    setEyes(flag);

    const text = texts == "password" ? "text" : "password";
    setTexts(text);
  };

  const handleEyess = () => {
    const flag = eyess == 0 ? 1 : 0;
    setEyess(flag);

    const text = textss == "password" ? "text" : "password";
    setTextss(text);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (!isUpdate) {
      const formData = new FormData();
      formData.append("firstname", formValue.firstname);
      formData.append("lastname", formValue.lastname);
      formData.append("email", formValue.email);
      formData.append("password", formValue.password);
      formData.append("role_id", formValue.role_id);
      formData.append("company_name", formValue.company_name);
      if (image) {
        formData.append("profile_image", image);
      }
      const regex =
        /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*[a-z])(?=.*[0-9]).{8,}$/;
      const trueData = regex.test(formValue.password);
      if (!trueData) {
        toast.error(
          "Password must contain at least one Uppercase letter, one Special cheracter"
        );
        setIsLoading(false);
      } else {
        if (formValue.password != formValue.new_password) {
          toast.error("Don't match Password & Confirm Password");
          setIsLoading(false);
        } else {
          addUsers(formData)
            .then((res) => {
              toast.success(res.data.message);
              setFormValue({});
              setIsAddUser(false);
              handleUserList();
            })
            .catch((err) => {
              if (err.response.status == 401) {
                Cookies.remove("e_learning_token");
                navigate("/login");
              } else {
                toast.error(err.response.data.message);
              }
              setIsLoading(false);
            });
        }
      }
    } else {
      const formData = new FormData();
      formData.append("firstname", formValue.firstname);
      formData.append("lastname", formValue.lastname);
      formData.append("email", formValue.email);
      formData.append("role_id", formValue.role_id);
      formData.append("company_name", formValue.company_name);
      formData.append("id", formValue.id);
      formData.append("user_role", "user");
      if (image) {
        formData.append("profile_image", image);
      }

      updateUsers(formData)
        .then((res) => {
          toast.success(res.data.message);
          setFormValue({});
          setIsAddUser(false);
          handleUserList();
        })
        .catch((err) => {
          if (err.response.status == 401) {
            Cookies.remove("e_learning_token");
            navigate("/login");
          } else {
            toast.error(err.response.data.message);
          }
          setIsLoading(false);
        });
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let obj = {
      user_id: userId.id,
    };
    deleteUsers(obj)
      .then((res) => {
        toast.success(res.data.message);
        const data = [...userData];
        data.splice(isIndex, 1);
        setUserData(data);
        setModalOpens(false);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setIsLoading(false);
      });
  };

  const handleView = (data, index) => {
    setModalOpens(true);
    setUserId(data);
    setIsIndex(index);
    setIsLoading(false);
  };

  const handleAdd = () => {
    setIsAddUser(true);
    setFormValue({});
    setIsLoading(false);
    setIsUpdate(false);
    setImage("");
    setImg("");
  };

  const handleEdit = (data) => {
    setIsUpdate(true);
    setFormValue(data);
    setIsAddUser(true);
    setIsLoading(false);
    setImg("");
    setImage("");
  };

  return (
    <>
      <div className="grid grid-cols-12 md:m-4 m-1 fontNew">
        <div className="col-span-12 duration-300 cursor-pointer">
          <div className="flex flex-wrap-reverse sm:justify-between justify-end mb-4 items-start">
            <div className="flex xl:w-70 sm:w-52 w-full h-10 px-4 sm:mb-0 mb-3 rounded-[8px] bg-white items-center">
              <input
                type="text"
                required
                className="bg-transparent  sm:w-70 w-full border-none outline-none h-10 text-sm fontNew"
                placeholder="Search..."
                name="search_text"
                value={searchData}
                onChange={handleSearchChange}
              />
            </div>
            <div className="flex items-center">
              <div className="mr-3">
                <div className="xl:w-52 sm:w-36 w-full sm:me-3 me-0">
                  <FormSelect
                    value={isRole}
                    onChange={(e) => {
                      setIsRole(e.target.value);
                      setPageNo(1);
                    }}
                    className="sm:me-3 sm:mb-0 mb-3 ps-5 pl-0 pb-0 pt-0 me-0 select-arrow-hidden text-sm rounded-[8px] font-medium xl:w-52 sm:w-36 w-full h-10 outline-none"
                  >
                    <option label="All"></option>
                    {userRoleData.map((item, index) => {
                      return (
                        <option key={index} value={item.id}>
                          {item.role_name}
                        </option>
                      );
                    })}
                  </FormSelect>
                </div>
              </div>
              <button
                onClick={handleAdd}
                className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-3 rounded-lg whitespace-nowrap"
              >
                <img src={add} className="w-6 mr-2" alt="" />
                Add User
              </button>
            </div>
          </div>
        </div>
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {userData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <>
                <div className="col-span-12">
                  <div
                    className="w-full lg:overflow-hidden overflow-auto"
                    onMouseDown={startDragging}
                    onMouseLeave={stopDragging}
                    onMouseUp={stopDragging}
                    onMouseMove={onDragging}
                    ref={scrollRef}
                  >
                    <table className="w-full border-separate border-spacing-y-3">
                      <thead>
                        <tr className="bg-white">
                          <th className="py-4 px-5 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>USER ID</h4>
                          </th>
                          <th className="py-4 px-5 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>USER</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>EMAIL</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>COMPANY</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>ROLE</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>POINT</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>JOIN DATE</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <div className="text-center">
                              <h4>ACTION</h4>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData.map((item, index) => {
                          const role = item?.User_Role;
                          return (
                            <tr key={index} className="font-medium bg-white">
                              <td className="text-start px-5 py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="lg:whitespace-normal whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base">{item.id || "-"}</p>
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="lg:whitespace-normal whitespace-nowrap lg:w-auto ps-3 w-52 flex items-center">
                                  <div className="w-10 h-10 rounded-full object-cover">
                                    <img
                                      src={
                                        item.profile_image
                                          ? IMG_URL + item.profile_image
                                          : user
                                      }
                                      className="min-w-10 h-10 rounded-full object-cover"
                                      alt=""
                                    />
                                  </div>
                                  <p className="text-base ms-3">
                                    {item.firstname || "-"}{" "}
                                    {item.lastname || ""}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="lg:whitespace-normal whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base">
                                    {item.email || "-"}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="lg:whitespace-normal whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base">
                                    {item.company_name || "-"}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="lg:whitespace-normal whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base">
                                    {(role && role.role_name) || "-"}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="lg:whitespace-normal whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base">
                                    {item.reward_point}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="lg:whitespace-normal whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base">
                                    {moment(item.createdAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start flex justify-center lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="flex items-center  justify-center">
                                  <div
                                    className="mr-4 lg:w-9 w-8 cursor-pointer"
                                    onClick={() => handleView(item, index)}
                                  >
                                    <img
                                      src={deletes}
                                      className="lg:w-9 w-8"
                                      alt="Delete"
                                    />
                                  </div>
                                  <div
                                    className="cursor-pointer lg:w-9 w-8"
                                    onClick={(e) => handleEdit(item)}
                                  >
                                    <img
                                      src={edit}
                                      className="lg:w-9 w-8"
                                      alt="Delete"
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                  <div className="flex items-center cursor-pointer">
                    <p
                      onClick={() => handlePageChange(pageNo - 1)}
                      disabled={pageNo === 1}
                    >
                      Previous
                    </p>
                    <div className="flex items-center mx-6">
                      {renderPaginationButtonss()}
                    </div>
                    <p
                      onClick={() => handlePageChange(pageNo + 1)}
                      disabled={pageNo === totalPage}
                    >
                      Next
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <Dialog open={isAddUser} onClose={() => setIsAddUser(false)} size="md">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="p-4 sm:w-auto w-[330px] md:h-[700px] h-[500px] overflow-auto fontNew">
              <h4 className="text-lg font-semibold mb-2">
                {isUpdate ? "Update" : "Add"} User
              </h4>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 flex items-center mx-2 my-3">
                    <div className="flex items-start">
                      <img
                        src={
                          img
                            ? img
                            : formValue.profile_image
                            ? IMG_URL + formValue.profile_image
                            : noImage
                        }
                        className="2xl:w-[106px] 2xl:h-[106px] w-[88px] h-[88px] rounded-full object-cover"
                        alt=""
                      />
                      {img ? (
                        <div
                          onClick={() => {
                            setImg("");
                          }}
                          className="bg-white rounded-full right-6 w-5 h-5 relative"
                        >
                          <img src={cancel} className="w-5" alt="" />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="ms-5">
                      <h4 className="text-base font-semibold">Profile Image</h4>
                      <p className="text-xs my-2 text-[#9C9DA9]">
                        Png, JPG, up to 5 MB
                      </p>
                      <div className="mt-6">
                        <label
                          htmlFor="upload-photo"
                          className="bg-[#FBFBFB] text-[#5A5A5A] border-dashed border-2 border-[#D9D9D9] py-3 px-5 rounded-lg text-sm font-normal"
                        >
                          Upload image
                        </label>
                        <input
                          type="file"
                          onChange={(e) => handleFile(e)}
                          className="hidden"
                          id="upload-photo"
                          accept="image/*"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="md:col-span-6 col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">First Name</h4>
                    <input
                      type="text"
                      name="firstname"
                      value={formValue.firstname || ""}
                      onChange={handleChange}
                      required
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="md:col-span-6 col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">Last Name</h4>
                    <input
                      type="text"
                      name="lastname"
                      value={formValue.lastname || ""}
                      onChange={handleChange}
                      required
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Select User Role
                    </h4>
                    <select
                      name="role_id"
                      value={formValue.role_id || ""}
                      onChange={handleChange}
                      required
                      className="select-arrow-hidden w-full outline-[#e1c595] border-2 px-4 py-3 rounded-md"
                    >
                      <option label="select role"></option>
                      {userRoleData.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.role_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">Email</h4>
                    <input
                      type="text"
                      name="email"
                      value={formValue.email || ""}
                      onChange={handleChange}
                      required
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">Company Name</h4>
                    <input
                      type="text"
                      name="company_name"
                      value={formValue.company_name || ""}
                      onChange={handleChange}
                      required
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  {isUpdate ? (
                    ""
                  ) : (
                    <>
                      <div className="col-span-12 md:mx-2 mx-0 my-3">
                        <h4 className="text-sm font-medium mb-3">Password</h4>
                        <div className="flex items-center">
                          <input
                            type={texts}
                            required
                            className="bg-transparent ps-4 pe-12 rounded-md border-2 w-full outline-[#e1c595] h-[54px] text-base"
                            placeholder="Password"
                            name="password"
                            minLength={8}
                            onChange={handleChange}
                          />
                          {eyes == 0 ? (
                            <img
                              src={EyeSlash}
                              onClick={handleEyes}
                              className="p-2 w-10 h-10 -ms-12 cursor-pointer"
                              alt=""
                            />
                          ) : (
                            <img
                              src={Eye}
                              onClick={handleEyes}
                              className="p-2 w-10 h-8 -ms-12 cursor-pointer"
                              alt=""
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-span-12 md:mx-2 mx-0 my-3">
                        <h4 className="text-sm font-medium mb-3">
                          Confirm Password
                        </h4>
                        <div className="flex items-center">
                          <input
                            type={textss}
                            required
                            className="bg-transparent ps-4 pe-12 rounded-md border-2 w-full outline-[#e1c595] h-[54px] text-base"
                            placeholder="Password"
                            name="new_password"
                            minLength={8}
                            onChange={handleChange}
                          />
                          {eyess == 0 ? (
                            <img
                              src={EyeSlash}
                              onClick={handleEyess}
                              className="p-2 w-10 h-10 -ms-12 cursor-pointer"
                              alt=""
                            />
                          ) : (
                            <img
                              src={Eye}
                              onClick={handleEyess}
                              className="p-2 w-10 h-8 -ms-12 cursor-pointer"
                              alt=""
                            />
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsAddUser(false)}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-[#00987C] text-white h-[45px] w-30 rounded-lg"
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      `${isUpdate ? "Update" : "Add"}`
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isModalOpens}
        onClose={() => setModalOpens(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div>
              <img src={back} className="w-auto relative" alt="" />
              <div className="flex justify-center">
                <img
                  src={
                    userId.profile_image
                      ? IMG_URL + userId.profile_image
                      : noImage
                  }
                  className="object-cover absolute sm:w-24 sm:h-24 w-14 h-14 lg:-mt-36 md:-mt-30 sm:-mt-36 -mt-24 rounded-full border-2 "
                  alt=""
                />
              </div>
            </div>
            <div className="flex justify-center text-center my-4 sm:px-16 px-5 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete User?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure want to delete {userId.firstname || ""}{" "}
                  {userId.lastname || ""} from the user?
                </p>
                <div className="flex items-center justify-center mt-16 mb-10">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setModalOpens(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </>
  );
}

export default Users;
